import React from 'react';
import PropTypes from 'prop-types';
// import withStyles from 'isomorphic-style-loader/lib/withStyles';

import { deleteAuthCookie } from '../../utils/cookie';
import history from '../../history';
import LogoutOverlay from '../../components/LogoutOverlay';

const REDIRECT_TIMEOUT = 1000;
const logoutUser = deleteAuthCookie;

class Logout extends React.Component {
  static propTypes = {
    redirect: PropTypes.string,
  };

  static defaultProps = {
    redirect: null,
  };

  componentDidMount() {
    logoutUser();
    this.redirectAfterLogout();
  }

  redirectAfterLogout = () => {
    const { redirect } = this.props;
    if (redirect) {
      setTimeout(() => window.location.replace(redirect), REDIRECT_TIMEOUT);
      return;
    }

    setTimeout(() => history.push('/'), REDIRECT_TIMEOUT);
  };

  render() {
    return (
      <div style={{ minHeight: '100vh' }}>
        <LogoutOverlay />{' '}
      </div>
    );
  }
}

export default Logout;



// WEBPACK FOOTER //
// ./src/routes/logout/Logout.js